import { api } from "@/lib/api";
import { splitAcademySeniors, carryStyles } from "@/lib/posterTemplate";

const STYLE_KEYS = ["band", "color_primary", "color_accent", "background_url", "gold_lines", "logo_url", "show_logo", "highlight_team", "highlight_first_team", "team_name"];
const styleOf = (p) => Object.fromEntries(STYLE_KEYS.filter((k) => p[k] !== undefined).map((k) => [k, p[k]]));

export const upsertSplit = async (p, kinds = ["senior", "academy"]) => {
  const { academy, senior } = splitAcademySeniors(p);
  const { data: list } = await api.get("/posters");
  const out = [];
  for (const [kind, x] of [["senior", senior], ["academy", academy]].filter(([k]) => kinds.includes(k))) {
    const ex = list.find((q) => q.split_of === p.id && q.split_kind === kind);
    out.push(ex
      ? (await api.put(`/posters/${ex.id}`, { ...carryStyles(ex, { ...ex, ...styleOf(x), top: x.top, columns: x.columns, footer: [] }), overlays: [], show_footer: false, show_columns: true, show_scores: p.show_scores })).data
      : (await api.post("/posters", { ...x, overlays: [], locked: false, source_poster_id: "", split_of: p.id, split_kind: kind })).data);
  }
  return out;
};
